/* import __COLOCATED_TEMPLATE__ from './collection-page.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();